var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastMessageSelections && _vm.lastMessageSelections?.length)?_c('div',{ref:"chatQuestions",staticClass:"chat-selection"},_vm._l((_vm.lastMessageSelections),function(selection,index){return _c('button',{key:index,staticClass:"chat-selection-item",class:[selection.action === 'next_step' ? 'action_next' : '', selection.action_style ? selection.action_style : ''],attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.buttonClick({
    text: _vm.$t(selection.name),
    value: selection.value,
    text_without_t: selection.name,
    action: selection.action,
    ai_question: _vm.$t(selection.ai_question),
  })}}},[(_vm.qcmResultsKeys.includes(selection.value))?_c('i',{staticClass:"material-icons check-done"},[_vm._v("check_circle")]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(selection.name))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }